import React from 'react';
import classnames from 'classnames';

import Icon from 'components/atoms/Icon';

import { LANGUAGE_OPTIONS, mapLanguageName } from 'util/i18n';

import styles from './index.css';

const LanguageButton = ({ lan, select, className }) => (
	<div className={classnames(styles.outer, className)} lang={lan}>
		<button className={styles.languageButton}>
			<div className={`${styles.wrap} ${styles.icon}`}>
				<Icon light>translate</Icon>
			</div>
			<div className={styles.wrap}>
				<span>{mapLanguageName(lan)}</span>
				<Icon>keyboard_arrow_down</Icon>
			</div>
		</button>
		<div className={styles.dropdown}>
			{LANGUAGE_OPTIONS.map(item => (
				<div
					key={item.value}
					className={styles.item}
					onKeyPress={() => {}}
					role="button"
					tabIndex="0"
					onClick={() => select(item.value)}
				>
					{item.label}
				</div>
			))}
		</div>
	</div>
);

export default LanguageButton;



// WEBPACK FOOTER //
// ./src/components/atoms/LanguageButton/component.js